import PS_LOGO_IMG from 'assets/img/logos/primary/Powershades_Logo_200.png';

import AddressBlock from './AddressBlock';
import Page from './Page';
import AccessoriesTable from './AccessoriesTable';
import ShadesTable from './ShadesTable';
import TotalPrice from '../TotalPrice';

const QuoteInfoPage = ({
	quote, shades, newQuote
}) => {
	const displayData = newQuote.MRSPData();

	return (
		<>
			<Page className="quote-info">
				<div className="container">
					<div className="top-row">
						<h1>
							{quote.is_order ? 'Order' : 'Quote'}
							&nbsp;
							#
							{quote.ID}
						</h1>

						<img src={PS_LOGO_IMG} alt="powerShades-log" />
					</div>

					<div className="options-row">
						<span>
							Title:
							{quote.title}
						</span>
						<span>
							Reference #:
							{quote.reference_number}
						</span>
					</div>
				</div>

				<AddressBlock address={quote.property_address} label="Property" />

				<AddressBlock address={quote.shipping_address} label="Shipping Address" />
			</Page>

			<ShadesTable quote={quote} shades={shades} displayData={displayData} />

			<Page>
				<AccessoriesTable quote={quote} displayData={displayData} />
			</Page>

			<Page>
				<span
					className="total-price-container"
					style={{
						
					}}
				>
					<TotalPrice
						key={`pricetotals-${quote.ID}`}
						className="total-price"
						msrpIsoOnlyisPrint
						quoteTotals={displayData}
						moneyFunctions={newQuote.Money.moneyFunctions}
						total_price={quote?.totalPrice()}
						quote={quote}
					/>
				</span>
			</Page>
		</>
	);
};

export default QuoteInfoPage;
